import { render, staticRenderFns } from "./Joke.vue?vue&type=template&id=2688cfe4&scoped=true&"
import script from "./Joke.vue?vue&type=script&lang=js&"
export * from "./Joke.vue?vue&type=script&lang=js&"
import style0 from "./Joke.vue?vue&type=style&index=0&id=2688cfe4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688cfe4",
  null
  
)

export default component.exports